import * as currenciesApi from "app/api/currenciesApi";
import * as api from "app/api/registrationApi";
import { fetchHeardAboutUsOptions } from "app/api/registrationApi";
const registrationFormModel = {
  state: {
    isRegistrationModalOpen: false,
    countries: [],
    listOfCurrencies: [],
    listOfHeardAbout: [],
    successfulRegistration: false,
    isSubmitting: false,
    isSubmittingError: false,
    isSubmittingSuccess: false,
    isCanadaSelected: false,
  },
  reducers: {
    setRegistrationModalOpen: (state: Record<string, any>) => {
      return {
        ...state,
        isRegistrationModalOpen: true,
      };
    },
    setIsCanadaSelected: (state: Record<string, any>, payload: boolean) => {
      return {
        ...state,
        isCanadaSelected: payload,
      };
    },
    setRegistrationModalClosed: (state: Record<string, any>) => {
      return {
        ...state,
        isRegistrationModalOpen: false,
        successfulRegistration: false,
      };
    },
    setCountries: (
      state: Record<string, any>,
      payload: Array<{ name: string; code: string }>
    ) => {
      return {
        ...state,
        countries: payload,
      };
    },
    setListOfCurrencies: (
      state: Record<string, any>,
      payload: Array<{ name: string; code: string }>
    ) => {
      return {
        ...state,
        listOfCurrencies: payload,
      };
    },
    setListOfHeardAbout(
      state: Record<string, any>,
      payload: Array<{ id: string; name: string }>
    ): any {
      return {
        ...state,
        listOfHeardAbout: payload,
      };
    },
    setSuccessfulRegistration(
      state: Record<string, any>,
      payload: boolean
    ): any {
      return {
        ...state,
        successfulRegistration: payload,
      };
    },
    setIsSubmitting(state: Record<string, any>, payload: boolean): any {
      return {
        ...state,
        isSubmitting: payload,
      };
    },
  },
  effects: {
    async getCountries(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      // Fetch countries for registration
      api
        .fetchCountriesForPublicRegistration()
        .then((response: any) => {
          this.setCountries(response);
        })
        .catch(error => console.log("fetch get countries failed"));
    },
    async getCurrenciesList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      // Fetch currencies for registration
      currenciesApi.fetchRegistrationCurrencies().then(resp => {
        this.setListOfCurrencies(resp.currencies);
      });
    },
    async getHeardAboutUs(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      // Fetch heard about us options
      // get heard about us list
      fetchHeardAboutUsOptions()
        .then((response: any) => {
          this.setListOfHeardAbout(response.options);
        })
        .catch(error => console.log("fetch get heard about us failed"));
    },
    async submitRegistrationForm(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setIsSubmitting(true);
      api
        .createAccount({
          username: payload.username,
          password: payload.password,
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          dateOfBirth: payload.dateOfBirth,
          contactNumber: payload.contactNumber,
          addressLine1: payload.addressLine1,
          addressLine2: payload.addressLine2,
          city: payload.city,
          state: payload.state,
          postCode: payload.postCode,
          country: payload.country,
          currency: payload.currency,
          gRecaptchaResponse: payload.gRecaptchaResponse,
          heardAboutUs: payload.heardAboutUs,
          consentToMarketing: payload.consentToMarketing,
          promoCode: payload.promoCode,
          acceptedTCs: payload.consentToTermsAndConditions,
          language: "en",
          affiliateType: payload.affiliateType,
        })
        .then(response => {
          console.log("response", response);
          this.setIsSubmitting(false);
          if (response.data) {
            this.setSuccessfulRegistration(true);
          }
        })
        .catch(error => {
          console.log("error", error);
          this.setIsSubmitting(false);
        });
    },
  },
};
export default registrationFormModel;
